<template>
  <v-row justify="center">
    <v-dialog v-model="deleteMicro" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Confirmation</v-card-title>
        <v-card-text>
          You are about to delete this item , Are you sure you want to continue
          ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeForm()">
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="loadingDelete"
            @click="ConfirmationDelete()"
            data-cy="deleteConfirm"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      loadingDelete: false,
    };
  },
  props: ["deleteMicro", "deleteItem"],
  computed: {},
  methods: {
    ConfirmationDelete() {
      this.loadingDelete = true;
      this.$store
        .dispatch("DeleteToAPI", "/admin/micro/" + this.deleteItem.microid)
        .then((response) => {
          this.$store.dispatch("PushSuccessMsg", response.data.message);
          this.loadingDelete = false;
          this.$emit("DialogClose", true);
        })
        .catch((error) => {
          this.loadingDelete = false;
          this.$store.dispatch("PushErrorMsg", error.data.message);
        });
    },
    closeForm() {
      this.$emit("DialogClose", false);
    },
  },
};
</script>

